var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pl-6 mt-4 pt-2 pr-6 mb-6" },
    [
      [
        _c(
          "div",
          {
            staticClass:
              "mt-20 bg-white rounded-lg shadow my-2 h-24 w-40 justify-center",
          },
          [
            _c("div", { staticClass: "flex justify-center" }, [
              _c(
                "p",
                { staticClass: "text-lg font-bold justify-center mt-6" },
                [_vm._v(_vm._s(_vm.itemNumber))]
              ),
            ]),
            _c("p", { staticClass: "text-sm font-semibold text-center" }, [
              _vm._v(_vm._s(_vm.itemTitle)),
            ]),
          ]
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }